import React from "react"
import {
  type IconProps,
  iconColorCss,
  iconSizeCss,
} from "@myvp/shared/src/styles/icon-utils"
import RtlSvg from "@myvp/shared/src/icons/rtl-svg"

const Help = (props: IconProps) => (
  <RtlSvg
    className={props.className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={[
      iconSizeCss(props.size ?? "small"),
      iconColorCss(props.color ?? "default"),
    ]}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM6.38898 5.61333C6.1099 5.95887 6 6.42622 6 6.875H5C5 6.28825 5.1401 5.5681 5.61102 4.98502C6.09784 4.38226 6.87803 4 8 4C8.86319 4 9.61779 4.28952 10.1596 4.81195C10.7021 5.33512 11 6.06225 11 6.875C11 7.3543 10.8965 7.76538 10.6958 8.10686C10.4948 8.44884 10.2135 8.69179 9.90366 8.86081C9.46714 9.09894 8.96252 9.19643 8.5 9.23198V10H7.5V8.75V8.25H8C8.53285 8.25 9.05226 8.18614 9.42477 7.98294C9.60185 7.88634 9.73847 7.7621 9.83364 7.60017C9.9291 7.43775 10 7.2082 10 6.875C10 6.31275 9.79789 5.85238 9.46543 5.5318C9.13221 5.21048 8.63681 5 8 5C7.12197 5 6.65216 5.28748 6.38898 5.61333ZM8.5 12V11H7.5V12H8.5Z"
      fill="var(--color)"
    />
  </RtlSvg>
)

export default Help
